import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "antd";

// IMAGES
import bulb from "../../img/bulb.png";

function LetsStart() {
    return (
        <div className="letsStart">
            <div className="custom-container">
                <div className="">
                    <div className="title">
                        <h1>LETS GET STARTED</h1>
                    </div>
                    <Row>
                        <Col xs={{ span: 24 }} md={{ span: 14 }}>
                            <div className="letsStart__quote">
                                <h2>
                                    Have an Idea you want to work on lets do it
                                    together
                                </h2>
                                <p>Bring Your Wild Ideas into reality</p>
                                <Link href="" to={"/"} className="hover-e1">
                                    <span className="border-left"></span>
                                    <span className="border-right"></span>
                                    <span className="border-top"></span>
                                    <span className="border-bottom"></span>
                                    Contact Us
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="bg-bulb">
                    <img src={bulb} alt="" />
                </div>
                <div className="bg-dot">
                    <svg
                        width="246"
                        height="223"
                        viewBox="0 0 246 223"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g opacity="0.12">
                            <ellipse
                                cx="83.7937"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="4.84284"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="24.2142"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="43.5855"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="62.9571"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="82.3282"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="101.7"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="121.071"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="140.442"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="159.814"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="179.185"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="198.556"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="198.556"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="198.556"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="198.556"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="198.556"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="208.242"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="196.942"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="198.556"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="198.556"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="198.556"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="83.7937"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="109.931"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="136.069"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="162.206"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="188.344"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="214.481"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="240.619"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="57.6563"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="31.5188"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                            <ellipse
                                cx="5.38125"
                                cy="217.928"
                                rx="5.38125"
                                ry="4.84284"
                                fill="white"
                            />
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    );
}

export default LetsStart;
